import { Result } from './model';
var NUMBER_REGEX = /^-?\d*(\.\d+)?$/;
var isNumber = function (value) {
    return typeof value === 'number' && !isNaN(value);
};
var isNumberString = function (value) {
    return typeof value === 'string' && value !== '' && NUMBER_REGEX.test(value);
};
export var asNumber = function (value, path) {
    if (isNumber(value)) {
        return Result.ok(value);
    }
    else if (isNumberString(value)) {
        return Result.ok(+value);
    }
    return Result.error([{ path: path, expected: 'number' }]);
};
